// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"353":"contact","594":"about","652":"service","946":"news"}[chunkId] + "." + {"353":"4052a6ff","594":"b83885db","652":"135a1a67","946":"9bfaf5a9"}[chunkId] + ".js";
};